import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;

export class ARMarkerFoundBlock extends AbstractBlock {
  constructor() {
    super('ar-marker-found', t.to('ARマーカーが反応した時の処理', 'ar_marker_found'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setARColor(block);
    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.setSceneStartShape(block);
    const marker_name = new Blockly.FieldTextInput('marker');
    block
      .appendDummyInput()
      .appendField(`${t.to('変数', 'variant_title')}[`)
      .appendField(marker_name, 'marker_name')
      .appendField(`]${t.to('に反応したマーカーの値をセット', 'set_at_found_marker')}`);

    // ShapeSettings.addAttributeInput(block);
    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    // attribute = CodeSetting.getSubAttributeCode(block);
    const marker_name = CodeSetting.getFieldValue(block, 'marker_name');

    const sub = CodeSetting.getSubstatementCode(block);
    const str = `document.addEventListener("markerFound",(e)=>{
			let ${marker_name} = e.srcElement.getAttribute("value");
			${sub}
		})`;
    return str;
  }
}
